import React, { PureComponent } from 'react'
import { css } from 'emotion'
import { PageHeader } from 'components'
import { homebg2 } from 'images'

class Container extends PureComponent {
  render() {
    const { children, className } = this.props
    const classNames = css(className, styles.container)
    return (
      <section className={classNames}>
        <PageHeader />
        {children}
      </section>
    )
  }
}

const styles = {
  container: css({
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: `url(${homebg2}) repeat`,
    backgroundSize: 'tile',
  }),
}

export default Container
